(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Prevent buy button from toggling accordion and close menu on link click
  document.addEventListener('DOMContentLoaded', function () {
    const accordion = document.querySelector('.header__submenu-accordion--mobile');
    if (accordion) {
      const buyButton = accordion.querySelector('.header__submenu-buy-button');
      const buyForm = accordion.querySelector('form');

      if (buyButton && buyForm) {
        buyForm.addEventListener('click', function (e) {
          e.stopPropagation();
        });

        buyButton.addEventListener('click', function (e) {
          e.stopPropagation();
        });
      }

      // Close accordion when a menu link is clicked
      const menuLinks = accordion.querySelectorAll('.header__submenu-list--mobile a');
      menuLinks.forEach(function (link) {
        link.addEventListener('click', function () {
          accordion.removeAttribute('open');
          const summary = accordion.querySelector('summary');
          if (summary) {
            summary.setAttribute('aria-expanded', 'false');
          }
        });
      });
    }
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parallel-logo-block"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('logo-block-carousel')) {
  class LogoBlockCarousel extends HTMLElement {
    connectedCallback() {
      this.slider = this.querySelector('[data-logo-slider]');
      if (!this.slider) return;

      this.slides = Array.from(this.slider.querySelectorAll('[data-logo-slide]'));
      this.autoplayEnabled = this.getAttribute('data-autoplay') === 'true';
      this.speed = Number(this.getAttribute('data-speed') || 4) * 1000;
      this.columns = Number(this.getAttribute('data-columns') || 2);
      this.mobileQuery = window.matchMedia('(max-width: 749px)');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.isVisible = false;
      this.userPaused = false;
      this.timer = null;

      this.syncPlayback = this.syncPlayback.bind(this);
      this.pause = this.pause.bind(this);
      this.onPointerDown = this.onPointerDown.bind(this);
      this.onPointerUp = this.onPointerUp.bind(this);
      this.onVisibility = this.onVisibility.bind(this);

      this.mobileQuery.addEventListener('change', this.syncPlayback);
      this.reducedMotion.addEventListener('change', this.syncPlayback);
      this.slider.addEventListener('pointerdown', this.onPointerDown);
      this.slider.addEventListener('pointerup', this.onPointerUp);
      this.slider.addEventListener('pointercancel', this.onPointerUp);
      this.addEventListener('mouseenter', this.pause);
      this.addEventListener('mouseleave', this.syncPlayback);
      this.addEventListener('focusin', this.pause);
      this.addEventListener('focusout', this.syncPlayback);

      this.visibilityObserver = new IntersectionObserver(this.onVisibility, {
        threshold: 0.35,
      });
      this.visibilityObserver.observe(this);
      this.syncPlayback();
    }

    disconnectedCallback() {
      this.pause();
      if (this.resumeTimeout) clearTimeout(this.resumeTimeout);
      if (this.visibilityObserver) this.visibilityObserver.disconnect();
      if (this.mobileQuery) this.mobileQuery.removeEventListener('change', this.syncPlayback);
      if (this.reducedMotion) this.reducedMotion.removeEventListener('change', this.syncPlayback);
      if (this.slider) {
        this.slider.removeEventListener('pointerdown', this.onPointerDown);
        this.slider.removeEventListener('pointerup', this.onPointerUp);
        this.slider.removeEventListener('pointercancel', this.onPointerUp);
      }
      this.removeEventListener('mouseenter', this.pause);
      this.removeEventListener('mouseleave', this.syncPlayback);
      this.removeEventListener('focusin', this.pause);
      this.removeEventListener('focusout', this.syncPlayback);
    }

    onVisibility(entries) {
      this.isVisible = entries.some((entry) => entry.isIntersecting);
      this.syncPlayback();
    }

    onPointerDown() {
      this.userPaused = true;
      this.pause();
    }

    onPointerUp() {
      if (this.resumeTimeout) clearTimeout(this.resumeTimeout);
      this.resumeTimeout = setTimeout(() => {
        this.userPaused = false;
        this.syncPlayback();
      }, this.speed);
    }

    get shouldPlay() {
      return (
        this.autoplayEnabled &&
        this.isVisible &&
        !this.userPaused &&
        this.mobileQuery.matches &&
        !this.reducedMotion.matches &&
        this.slides.length > this.columns
      );
    }

    get pageOffset() {
      if (this.slides.length <= this.columns) return this.slider.clientWidth;
      return this.slides[this.columns].offsetLeft - this.slides[0].offsetLeft;
    }

    syncPlayback() {
      if (!this.mobileQuery.matches) {
        this.pause();
        this.slider.scrollTo({ left: 0 });
        return;
      }

      if (this.shouldPlay) {
        this.play();
      } else {
        this.pause();
      }
    }

    play() {
      this.pause();
      if (!this.shouldPlay) return;
      this.timer = setInterval(() => this.next(), this.speed);
    }

    pause() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    next() {
      if (!this.slider || !this.shouldPlay) return;

      const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;
      const nextLeft = this.slider.scrollLeft + this.pageOffset;
      const atEnd = nextLeft >= maxScroll - 4;

      this.slider.scrollTo({
        left: atEnd ? 0 : nextLeft,
        behavior: atEnd ? 'auto' : 'smooth',
      });
    }
  }

  customElements.define('logo-block-carousel', LogoBlockCarousel);
}

  } catch(e) { console.error(e); }
})();
})();
